<template>
  <v-menu>
    <template #activator="{on, attrs}" ref="userActions">
      <v-icon color="primary" v-bind="attrs" v-on="on">
        mdi-dots-vertical
      </v-icon>
    </template>
    <v-list dense>
      <v-list-item>
        <v-icon color="primary" @click="$emit('menuAction', { method: 'remind', pro_user })">
          mdi-email-fast-outline
        </v-icon>
      </v-list-item>
      <v-list-item @click="$emit('menuAction', { method: 'delete', pro_user } )">
        <v-icon color="primary">
          mdi-trash-can-outline
        </v-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name:  'UserActions',

  props: ['pro_user'],
}
</script>